import React from "react";
import GroupSelectionType from "../GroupSelectionType/GroupSelectionType";
import GroupMultiSelect from "../GroupMultiSelect/GroupMultiSelect";
import useGroupSelector from "../../hooks/useGroupSelector";
import "./GroupSelector.css";

const GroupSelector = ({
  allGroups = [],
  onChange,
  typeLabel = "Target Audience",
  selectLabel,
  selectPlaceholder,
  disabled = false,
  selectedGroups = null,
}) => {
  const {
    selectionType,
    selectedOptions,
    handleSelectionTypeChange,
    handleSelectedOptionsChange,
  } = useGroupSelector(allGroups, onChange, selectedGroups);

  const showMultiSelect =
    selectionType === "region" ||
    selectionType === "country" ||
    selectionType === "group";

  return (
    <div className="group-audience-selector">
      <GroupSelectionType
        value={selectionType}
        onChange={handleSelectionTypeChange}
        label={typeLabel}
        disabled={disabled}
      />

      {showMultiSelect && !disabled && (
        <GroupMultiSelect
          type={selectionType}
          allGroups={allGroups}
          selectedOptions={selectedOptions}
          onChange={handleSelectedOptionsChange}
          label={selectLabel}
          placeholder={selectPlaceholder}
        />
      )}
    </div>
  );
};

export default GroupSelector;
